import * as React from 'react';
import { StoreContext } from '../../utils';
import { PortalDesktopSearch } from '../DesktopSearch/PortalDesktopSearch';
import { PortalHeaderLogo } from './PortalHeaderLogo';
import { PortalHeaderDropdown } from './PortalHeaderDropdown';
import { PortalHeaderTopbar } from './PortalHeaderTopbar';
import { Store } from '../../store/Store';

export class PortalHeader extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { userStore, portalStore, requestStore } = this.context;

    if (requestStore.requestData.isWebviewInApp) return null;
    if (requestStore.requestData.isInlineViewInWeb) return null;

    return (
      <div id="kt_header" className="header flex-column header-fixed">
        {/*begin::Top*/}
        <div className="header-top" style={{ height: 70 }}>
          {/*begin::Container*/}
          <div className="container-fluid">
            {/*begin::Left*/}
            <div className="d-none d-lg-flex align-items-center mr-3">
              {/*begin::Logo*/}
              <PortalHeaderLogo />
              {/*end::Logo*/}
              {/*begin::Dropdown*/}
              <PortalHeaderDropdown />
              {/*end::Dropdown*/}
            </div>
            {/*end::Left*/}
            {/*begin::Topbar*/}
            <PortalHeaderTopbar />
            {/*end::Topbar*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Top*/}
        {/*begin::Bottom*/}
        {false && (
          <div className="header-bottom">
            {/*begin::Container*/}
            <div className="container-fluid">
              {/*begin::Header Menu Wrapper*/}
              <div className="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
                {/*begin::Header Menu*/}
                <div id="kt_header_menu" className="header-menu header-menu-left header-menu-mobile header-menu-layout-default">
                  {/*begin::Header Nav*/}

                  {/*end::Header Nav*/}
                </div>
                {/*end::Header Menu*/}
              </div>
              {/*end::Header Menu Wrapper*/}
              {/*begin::Desktop Search*/}
              <PortalDesktopSearch />
              {/*end::Desktop Search*/}
            </div>
            {/*end::Container*/}
          </div>
        )}
        {/*end::Bottom*/}
      </div>
    );
  }
}
